const BASE_URL = process.env.REACT_APP_API_BASE_URL;
import { Response } from '../../utils/interfaces';
import { Perfil } from '../../utils/models';
import http from '../http/http';

export class AuthService {
  getLoginURL() {
    return `${BASE_URL}/auth/login`;
  }

  getLogoutURL() {
    return `${BASE_URL}/auth/ssologout`;
  }

  logout() {
    return http.post<never>(
      '/Auth/SsoLogout',
      {},
      {
        baseURL: BASE_URL,
      },
    );
  }

  getProfileUser() {
    return http.get<Response<Perfil>>('/Perfil');
  }

  getStudentLabel() {
    return http.get<Response<string>>('/Perfil/StudentLabel');
  }
}
